<div class="block-dialog">
  
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>{{ data.block ? 'edit' : 'add' }}</mat-icon>
      {{ data.block ? 'Editar bloqueo' : 'Añadir bloqueo' }}
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="blockForm" class="block-form">

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="info-box">
            <mat-icon>person</mat-icon>
            <span>{{ data.staffName }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha y hora inicio</mat-label>
            <input matInput type="datetime-local" formControlName="startAt" required>
            <mat-error *ngIf="blockForm.get('startAt').hasError('required')">
              La fecha y hora de inicio son obligatorias
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha y hora fin</mat-label>
            <input matInput type="datetime-local" formControlName="endAt" required>
            <mat-error *ngIf="blockForm.get('endAt').hasError('required')">
              La fecha y hora de fin son obligatorias
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Motivo</mat-label>
            <textarea matInput formControlName="reason" rows="3" 
                      placeholder="Mantenimiento, reunión interna, bloqueo temporal..."></textarea>
            <mat-hint align="end">{{ blockForm.get('reason').value?.length || 0 }}/500</mat-hint>
            <mat-error *ngIf="blockForm.get('reason').hasError('maxlength')">
              Máximo 500 caracteres
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-checkbox formControlName="isActive" class="active-checkbox">
            Bloqueo activo
          </mat-checkbox>
          <p class="checkbox-hint">
            <mat-icon>info</mat-icon>
            Si está desactivado, el bloqueo no afectará a la disponibilidad
          </p>
        </div>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button
      label="Cancelar"
      icon="close"
      variant="secondary"
      mat-dialog-close>
    </app-button>
    <app-button 
      [label]="data.block ? 'Guardar cambios' : 'Añadir bloqueo'"
      icon="save" 
      variant="primary" 
      [disabled]="blockForm.invalid"
      (click)="onSave()">
    </app-button>
  </mat-dialog-actions>

</div>
